
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.64 22.66h-4.4V12.39h-2.2V8.85h2.2V6.72c0-2.89 1.24-4.61 4.77-4.61h2.94v3.54h-1.84c-1.37 0-1.46.49-1.46 1.42l-.01 1.77h3.32l-.39 3.55h-2.93v10.27z","fill-rule":"evenodd","clip-rule":"evenodd"}})])
          )
        }
      }
    